export const TOGGABLE_THEME_PATHS = Object.freeze({
  '/brand/[slug]': true,
  '/manifesto': true,
});
